export const REDUX_OPTIONS_TYPES = {
  OPTIONS: 'OPTIONS',
  INITIALS: 'INITIALS'
}

export const dispatchOptions = (data) => (dispatch) => dispatch({
  type: REDUX_OPTIONS_TYPES.OPTIONS,
  payload: data
})

export const dispatchInitials = (data) => (dispatch) => dispatch({
  type: REDUX_OPTIONS_TYPES.INITIALS,
  payload: data
})
